import { UserPermission } from "config/constants"
import Reservation, { ReservationStatus } from "models/Reservation"
import { usePermissions } from "stores/permissions"
import { IApiLink } from "@/types"

interface IUseReservationSidebarActionButtonsParams {
    status: ReservationStatus | undefined
    viewOnly?: boolean
    linkDelete?: IApiLink
    linkReopen?: IApiLink
}

export default function useReservationActions({
    status,
    viewOnly,
    linkDelete,
    linkReopen,
}: IUseReservationSidebarActionButtonsParams) {
    const { hasPermission } = usePermissions()
    const hasReservationEditPermission = hasPermission(UserPermission.ReservationEdit)
    const hasOfferEditPermission = hasPermission(UserPermission.OfferEdit)

    return {
        canDelete: hasReservationEditPermission && !viewOnly && !!linkDelete && !!status
            && !Reservation.isReservationStatusSameOrAfter(
                status,
                ReservationStatus.confirmed
            ),
        canEdit: hasReservationEditPermission && !viewOnly && !!status
            && !Reservation.isReservationStatusSameOrAfter(
                status,
                ReservationStatus.closed
            ),
        canReopen: hasReservationEditPermission && !viewOnly && !!linkReopen,
        canCopyAsReservation: hasReservationEditPermission && !viewOnly,
        canCopyAsOffer: hasOfferEditPermission && !viewOnly
    }
}
